import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var CANPayoutsIA = function CANPayoutsIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "rcTW0Q",
    defaultMessage: [{
      "type": 0,
      "value": "Para poder começar a receber pagamentos, tem de configurar um routing number dos EUA que lhe permita receber pagamentos em USD através de um depósito ACH. Pode fazê-lo da seguinte forma:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "HC7U/H",
    defaultMessage: [{
      "type": 0,
      "value": "Registe uma conta multimoeda. Recomendamos que utilize a "
    }, {
      "children": [{
        "type": 0,
        "value": "OFX"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      LinkFormatting: OxfLinkFormatting
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "YNvT+t",
    defaultMessage: [{
      "type": 0,
      "value": "Quando tiver um routing number dos EUA, aceda às "
    }, {
      "children": [{
        "type": 0,
        "value": "Definições de conta"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "qfxObM",
    defaultMessage: [{
      "type": 0,
      "value": "Aceda ao separador "
    }, {
      "children": [{
        "type": 0,
        "value": "Pagamentos"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }],
    values: {
      LinkFormatting: function LinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "sjxp9Z",
    defaultMessage: [{
      "type": 0,
      "value": "Adicione os seus dados bancários, incluindo o nome do titular da conta, o routing number e o número da conta."
    }]
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "gAWP8i",
    defaultMessage: [{
      "type": 0,
      "value": "Quando a conta estiver verificada, os pagamentos são emitidos conforme indicado no calendário de pagamentos que escolher nas definições de conta."
    }]
  })));
};
var OxfLinkFormatting = function OxfLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: "https://www.ofx.com/p/faire/?pid=13968",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};